import { applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import persistState from 'redux-localstorage'
import thunk from 'redux-thunk';

const enhancer = composeWithDevTools(
    applyMiddleware(
        thunk
    ),
    persistState("authentication")
);

export default enhancer;


// WEBPACK FOOTER //
// ./src/redux/enhancer.js